import XDate from 'xdate';
import {isProOrPartyPassUser} from '~/CreateFabricInvitation/utils/experiments';
import {INIT_APP} from '~/common/fabric/constants';
import {getTimezone} from '~/common/utils';
import {USER_LOGGED_IN} from '~library/organisms/LoginModal/reducer';
import {UPDATE_EVENT_DETAILS} from './constants';

const timezone = getTimezone();

export const initialState = {
  address: {city: '', state: '', street: '', zip: ''},
  cohost: {name: '', email: ''},
  guestsUpdated: false,
  // biome-ignore lint/style/useNamingConvention: existing error
  host_ids: [],
  end: '',
  host: window.userName || '',
  location: '',
  notes: '',
  // biome-ignore lint/style/useNamingConvention: existing error
  pending_host_ids: [],
  request: {failed: false, pending: false, success: false},
  start: '',
  stop: '',
  // biome-ignore lint/style/useNamingConvention: existing error
  known_timezone_abbr: timezone?.timezoneAbbr || '',
  // biome-ignore lint/style/useNamingConvention: existing error
  known_timezone_name: timezone?.timezoneId || '',
  title: '',
  type: '',
  isPremium: false,
  hideUpsell: false,
  isUpsellMode: false,
  inEditMode: false,
  preventUpdateModal: false,
  hasUpgraded: false,
  confirmationType: '',
  // Data analytics tracking fields
  // biome-ignore lint/style/useNamingConvention: existing error
  tracking_gallery_category: '',
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_EVENT_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    case USER_LOGGED_IN:
      return {
        ...state,
        host: state.host || action.userName,
        isPremium: state.isPremium || isProOrPartyPassUser(action.subscriptionPlanName),
      };
    case INIT_APP: {
      const {event, user, template} = action.payload;
      const {host_ids, pending_host_ids} = event ?? {};

      if (!event)
        return {
          ...state,
          host: user.userName,
          isPremium: template.premium || isProOrPartyPassUser(window?.subscriptionPlanName),
          hideUpsell: template.premium,
          type: action.payload.category_event_type || template.event_type || '',
          title: template.display_name,
          // biome-ignore lint/style/useNamingConvention: existing error
          tracking_gallery_category: action.payload.category_id,
          isGiphyFeatureSwitchEnabled: action.payload.isGiphyFeatureSwitchEnabled,
        };

      const start = XDate(event.start_datetime);

      return {
        ...state,
        address: {
          city: event.city,
          state: event.state,
          street: event.street_address,
          zip: event.zip_code,
        },
        cohost: {name: event.cohost_name1, email: event.cohost_email1},
        end: event.end_datetime && new XDate(event.end_datetime),
        host: event.host_name || user.userName,
        // biome-ignore lint/style/useNamingConvention: existing error
        host_ids,
        location: event.location_name,
        notes: event.message,
        // biome-ignore lint/style/useNamingConvention: existing error
        pending_host_ids,
        start,
        stop: event.stop_datetime && new XDate(event.stop_datetime),
        // biome-ignore lint/style/useNamingConvention: existing error
        known_timezone_abbr: event.known_timezone_abbr || timezone.timezoneAbbr,
        // biome-ignore lint/style/useNamingConvention: existing error
        known_timezone_name: event.known_timezone_name,
        title: event.title,
        type: event.event_type,
        isPremium: event.is_fabric_premium || isProOrPartyPassUser(window?.subscriptionPlanName),
        hideUpsell: event.is_fabric_premium || event.is_upgrade,
        inEditMode: event.status === 'sending',
        // biome-ignore lint/style/useNamingConvention: existing error
        tracking_gallery_category: event.tracking_data?.gallery_category,
        isGiphyFeatureSwitchEnabled: action.payload.isGiphyFeatureSwitchEnabled,
      };
    }
    default:
      return state;
  }
};
